<template>
  <fieldset>
    <BusinessEntityIsVatRegistered
      v-model="isVatRegistered"
      :disabled="disabled"
      :market="market"
      name="is_vat_registered"
    />
    <div v-if="isVatRegistered && !hideVatNoInput" class="tw-my-2">
      <BusinessEntityInput
        v-if="isVatRegistered"
        v-model="vatNo"
        :disabled="disabled"
        :label="labelVat"
        name="vat_no"
        required
      />
    </div>

    <BusinessEntityVatChangeAlert
      v-if="vatRegisteredIsChanged && complianceData.doesNotHaveEmptyBill"
    />
  </fieldset>
</template>

<script>
import { computed, ref, watch } from 'vue'
import BusinessEntityIsVatRegistered from '@/components/compliances/BusinessEntity/BusinessEntityIsVatRegistered.vue'
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVatChangeAlert from '@/components/compliances/BusinessEntity/BusinessEntityVatChangeAlert.vue'
import { useMarketDependentValue } from '@/composables/markets'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityIsVatRegistered,
    BusinessEntityVatChangeAlert,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    market: {
      type: String,
      default: null,
    },
  },
  emits: ['update:businessEntity'],
  setup(props, { emit }) {
    const isVatRegistered = ref(
      props.businessEntity.taxNo !== null && props.businessEntity.taxNo !== '',
    )
    const isVatRegisteredOrig = ref(isVatRegistered.value)
    const vatRegisteredIsChanged = computed(
      () => isVatRegistered.value === isVatRegisteredOrig.value,
    )

    const internalBusinessEntity = ref(props.businessEntity)
    const vatNo = computed({
      get() {
        return props.businessEntity.taxNo
      },
      set(value) {
        internalBusinessEntity.value.taxNo = value
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })

    const hideVatNoInput = computed(() => props.market === 'DE')
    watch(isVatRegistered, (value) => {
      if (hideVatNoInput.value) {
        vatNo.value = value ? internalBusinessEntity.value.companyNo : null
      }
    })

    const { marketValue: labelVat } = useMarketDependentValue(
      props.market,
      {
        AU: $t('GST number'),
        SG: $t('GST number'),
      },
      $t('VAT number'),
    )

    return {
      hideVatNoInput,
      isVatRegistered,
      isVatRegisteredOrig,
      labelVat,
      vatNo,
      vatRegisteredIsChanged,
    }
  },
}
</script>
